module.exports = __webpack_public_path__ + "static/adjusttextsize-197ca453eff4767e6d8ae85499d10005.png";